import { CONTEXT_PATH } from './index';
import { get } from './request';

export const SERVICE_PATH = 'rest/resource/profile/isRiskyDevice';

export const isRiskyDevice = () => get<boolean>(`${CONTEXT_PATH}/${SERVICE_PATH}`);
